import React, { useContext } from 'react';
import SectionTitle from '../../property-partners-portal/components/SectionTitle/SectionTitle';
import NonEditionContent from './NonEditionContent';
import EditionContent from './EditionContent';
import { ContextSettings } from '../../contexts/SettingsContext';
import Clock from './Clock';
import CardPlaceholder from '../components/CardPlaceholder';
import GoBackHomeLink from '../GoBackHomeLink';
import Card from '../../muiComponents/Card';

const SettingsContainer = () => {
    const { isEditionMode, isLoading } = useContext(ContextSettings);
    return (
        <div className='settings__container'>
            <div className='page-title__container'>
                <SectionTitle title='settings' />
                <GoBackHomeLink loading={isLoading} />
            </div>
            <Clock />
            {isLoading ? (
                <CardPlaceholder />
            ) : (
                <Card className='padding40  position-relative'>
                    {isEditionMode ? <EditionContent /> : <NonEditionContent />}
                </Card>
            )}
        </div>
    );
};

export default SettingsContainer;
